import { getPath } from '@/router/common'
const baseUrl = {
  title: '单票申报',
  path: 'AcceptanceOfBill2'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'Index',
    component: () => import(/* webpackChunkName: "zctb" */ '@/views/acceptanceOfBill2/index.vue'),
    meta: {
      title: '单票申报'
    }
  }
]
